/* @flow */
import * as React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';

import styles from './styles.module.scss';
import SearchBar from './SearchBar';
import logoImg from '../../assets/images/logo.svg';
import Icon from '../../components/Icon';
import MenuPopover from '../../components/MenuPopover';
import Modal from '../../components/Modal';
import Toolbar from '../../components/Toolbar';
import OnDemandRequestsForm, { requestTypes } from '../../forms/OnDemandRequestsForm';
import actions from '../../redux/actions';
import { getSearchParams } from '../../redux/reducers/app';
import { getMediaSearchParams } from '../../redux/reducers/mediaSearch';
import { getTrackSearchParams } from '../../redux/reducers/trackSearch';
import { getNumberOfItemsInCart } from '../../redux/reducers/cart';
import { getSelectedProductionId } from '../../redux/reducers/productions';
import { getSelectedUsageId, getSessionUsageId, getUsages } from '../../redux/reducers/usages';
import { getWorklist1, getWorklist2 } from '../../redux/reducers/worklists';
import protonesUtils from '../../utils/protones';
import keys from 'config/keys';

import type {
  Translate,
  ReduxState,
  ReactRouterProps,
  Worklist,
  OnDemand,
  SearchParams,
  MediaSearchParams,
  TrackSearchParams,
} from '../../types';
import storage from 'services/storage';

const helpFormInitialValues = { id: 0, date: Date.now(), requestType: requestTypes.help };

const mapStateToProps = (state: ReduxState, ownProps) => {
  const usages = _.get(getUsages(state), 'data', []);
  const sessionUsageId = _.get(getSessionUsageId(state), 'data');
  const sessionUsage = usages.find(_ => _.id === sessionUsageId);
  return {
    ...ownProps,
    selectedUsageId: getSelectedUsageId(state),
    sessionUsageName: sessionUsage ? sessionUsage.name : 'Nessuno',
    selectedProductionId: getSelectedProductionId(state),
    numberOfItemsInCart: getNumberOfItemsInCart(state),
    worklist1: getWorklist1(state).data,
    worklist2: getWorklist2(state).data,
    searchParams: getSearchParams(state),
    mediaSearchParams: getMediaSearchParams(state),
    trackSearchParams: getTrackSearchParams(state),
  };
};

type Props = ReactRouterProps & {
  className?: string,
  selectedProductionId?: ?number,
  selectedUsageId?: ?number,
  sessionUsageName: string,
  selectedWorklistId?: ?number,
  numberOfItemsInCart: number,
  worklist1: Worklist,
  worklist2: Worklist,
  logout: typeof actions.logout,
  searchParams: SearchParams,
  mediaSearchParams: MediaSearchParams,
  trackSearchParams: TrackSearchParams,
  performMediaSearch: typeof actions.performMediaSearch,
  performTrackSearch: typeof actions.performTrackSearch,
  submitOnDemandRequest: typeof actions.submitOnDemandRequest,
  t: Translate,
  location: any,
};

type menuPopoverItem = { text: string, onClick: () => any, iconName: string };

type menuPopoverGroup = 'REPORT' | 'PROFILE' | 'INFO';

type State = {
  isMenuPopoverVisible: boolean,
  menuPopoverGroup: menuPopoverGroup,
  isAskHelopModalVisible: boolean,
};

class Header extends React.PureComponent<Props, State> {
  playerRef: any = null;
  state = {
    isMenuPopoverVisible: false,
    menuPopoverGroup: 'INFO',
    isAskHelopModalVisible: false,
  };

  _toggleReportVisibility = () => {
    const { isMenuPopoverVisible, menuPopoverGroup } = this.state;
    if (menuPopoverGroup !== 'REPORT' && isMenuPopoverVisible) {
      this.setState({ menuPopoverGroup: 'REPORT' });
    } else {
      this.setState({ menuPopoverGroup: 'REPORT', isMenuPopoverVisible: !isMenuPopoverVisible });
    }
  };

  _toggleProfileVisibility = () => {
    const { isMenuPopoverVisible, menuPopoverGroup } = this.state;
    if (menuPopoverGroup !== 'PROFILE' && isMenuPopoverVisible) {
      this.setState({ menuPopoverGroup: 'PROFILE' });
    } else {
      this.setState({ menuPopoverGroup: 'PROFILE', isMenuPopoverVisible: !isMenuPopoverVisible });
    }
  };

  _toggleInfoVisibility = () => {
    const { isMenuPopoverVisible, menuPopoverGroup } = this.state;
    if (menuPopoverGroup !== 'INFO' && isMenuPopoverVisible) {
      this.setState({ menuPopoverGroup: 'INFO' });
    } else {
      this.setState({ menuPopoverGroup: 'INFO', isMenuPopoverVisible: !isMenuPopoverVisible });
    }
  };

  _getSearchPlaceholder = () => {
    const { t } = this.props;
    switch (this.props.location.pathname) {
      case '/medias/search':
        return t('SEARCH_SUPPORTS');
      case '/tracks/search':
      default:
        return t('SEARCH_TRACKS');
    }
  };

  _handleSearchSubmit = (params: SearchParams) => {
    const {
      // searchParams,
      // mediaSearchParams,
      performMediaSearch,
      // trackSearchParams,
      performTrackSearch,
    } = this.props;
    switch (this.props.location.pathname) {
      case '/medias/search': {
        // performMediaSearch(_.merge({}, mediaSearchParams, searchParams));
        performMediaSearch(_.merge({ categoryIds: [] }, params));
        return;
      }
      case '/tracks/search': {
        // performTrackSearch(_.merge({}, trackSearchParams, searchParams));
        performTrackSearch(_.merge({}, params));
        return;
      }
      default: {
        // performTrackSearch(_.merge({}, trackSearchParams, searchParams));
        performTrackSearch(_.merge({}, params));
        // $FlowFixMe
        protonesUtils.goTo(this.props, protonesUtils.routes.tracks.find());
      }
    }
  };

  _handleWorklistClick = () => {
    let destination;
    if (this.props.selectedWorklistId === undefined) {
      destination = protonesUtils.routes.worklists.find();
    } else if (this.props.selectedWorklistId === null) {
      destination = protonesUtils.routes.worklists.create();
    } else {
      destination = protonesUtils.routes.worklists.get(this.props.selectedWorklistId);
    }
    protonesUtils.goTo(this.props, destination);
  };

  _handleWorklist1Click = event => {
    event.stopPropagation();
    const id = this.props.worklist1 && this.props.worklist1.id;
    if (typeof id === 'number') {
      const destination = protonesUtils.routes.worklists.get(id);
      protonesUtils.goTo(this.props, destination);
    } else {
      this._handleWorklistClick();
    }
  };

  _handleWorklist2Click = event => {
    event.stopPropagation();
    const id = this.props.worklist2 && this.props.worklist2.id;
    if (typeof id === 'number') {
      const destination = protonesUtils.routes.worklists.get(id);
      protonesUtils.goTo(this.props, destination);
    } else {
      this._handleWorklistClick();
    }
  };

  _handleUsageClick = () => {
    let destination;
    if (this.props.selectedUsageId === undefined) {
      destination = protonesUtils.routes.usages.find();
    } else if (this.props.selectedUsageId === null) {
      destination = protonesUtils.routes.usages.create();
    } else {
      destination = protonesUtils.routes.usages.get(this.props.selectedUsageId);
    }
    protonesUtils.goTo(this.props, destination);
  };

  _handleProductionClick = () => {
    let destination;
    if (this.props.selectedProductionId === undefined) {
      destination = protonesUtils.routes.productions.find();
    } else if (this.props.selectedProductionId === null) {
      destination = protonesUtils.routes.productions.create();
    } else {
      destination = protonesUtils.routes.productions.get(this.props.selectedProductionId);
    }
    protonesUtils.goTo(this.props, destination);
  };

  _handleCartClick = () => {
    protonesUtils.goTo(this.props, protonesUtils.routes.cart.items.find());
  };

  _handleAskHelpSubmit = async (request: OnDemand) => {
    await this.props.submitOnDemandRequest(request);
    this.setState({ isAskHelopModalVisible: false });
  };

  render() {
    const { className, location, logout, t } = this.props;
    const { isMenuPopoverVisible, menuPopoverGroup, isAskHelopModalVisible } = this.state;

    const links = [
      {
        to: '/news',
        label: t('NEWS'),
        icon: 'news',
        isActive: (match, location) => location.pathname.startsWith('/news'),
      },
      {
        to: '/smartlists',
        label: t('SMARTLISTS'),
        icon: 'smartlist',
        isActive: (match, location) => location.pathname.startsWith('/smartlists'),
      },
      {
        to: '/featured',
        label: t('FEATURED'),
        icon: 'star_border',
        isActive: (match, location) => location.pathname.startsWith('/featured'),
      },
      {
        to: '/tracks/search',
        label: t('TRACKS'),
        icon: 'track',
        isActive: (match, location) => location.pathname.startsWith('/tracks'),
      },
      {
        to: '/medias/search',
        label: t('SUPPORTS'),
        icon: 'support',
        isActive: (match, location) => location.pathname.startsWith('/medias'),
      },
    ];
    const reportItems = [
      {
        text: t('PURCHASE_HISTORY'),
        // $FlowFixMe
        onClick: () => protonesUtils.goTo(this.props, protonesUtils.routes.purchases.find()),
        iconName: 'shopping_cart',
      },
    ];
    const profileItems = [
      // {
      //   text: t('PROFILE_SETTINGS'),
      //   // $FlowFixMe
      //   onClick: () => protonesUtils.goTo(this.props, protonesUtils.routes.profile.find()),
      //   iconName: 'settings',
      // },
      {
        text: storage.getFromStorage('user') && JSON.parse(storage.getFromStorage('user')).username,
        onClick: () => null,
        iconName: 'person',
      },
      { text: t('LOGOUT'), onClick: logout, iconName: 'logout' },
    ];
    const infoItems = [
      {
        text: t('PRICE_LISTS'),
        // $FlowFixMe
        onClick: () =>
          protonesUtils.openInNewTab(this.props, protonesUtils.routes.pricelists.find()),
        iconName: 'list',
      },
      {
        text: t('TUTORIAL'),
        // $FlowFixMe
        onClick: () => protonesUtils.openInNewTab(this.props, protonesUtils.routes.tutorial.find()),
        iconName: 'info',
      },
      {
        text: t('LEGAL_NOTES'),
        // $FlowFixMe
        onClick: () =>
          protonesUtils.openInNewTab(this.props, protonesUtils.routes.legalNotes.find()),
        iconName: 'list',
      },
      {
        text: t('HELP'),
        // $FlowFixMe
        onClick: () => {
          this.setState({ isAskHelopModalVisible: true });
        },
        iconName: 'contact_support',
      },
    ];

    if (keys.DISPLAY_VERSION) {
      infoItems.push({
        text: `V. ${keys.DISPLAY_VERSION}`,
        onClick: () => null,
      });
    }

    let menuPopoverItems: menuPopoverItem[] = [];
    switch (menuPopoverGroup) {
      case 'REPORT':
        menuPopoverItems = reportItems;
        break;
      case 'PROFILE':
        menuPopoverItems = profileItems;
        break;
      case 'INFO':
        menuPopoverItems = infoItems;
        break;
      default:
        menuPopoverItems = [];
    }
    return (
      <div className={classNames(className, styles.header)}>
        <div className={styles.logo}>
          <img src={logoImg} alt="logo" />
        </div>
        <div className={styles.headerContent}>
          <Toolbar>
            <SearchBar
              placeholder={this._getSearchPlaceholder()}
              onSearchSubmit={this._handleSearchSubmit}
            />
            <div className={styles.headerButtons}>
              <div className={styles.worklistButton} onClick={this._handleWorklistClick}>
                <div
                  className={classNames(
                    styles.worklistButtonLeft,
                    location.pathname.startsWith('/worklists') && styles.isActive
                  )}
                >
                  <Icon name={'worklist'} size="default" />
                  {t('WORKLIST')}
                </div>
                <div className={styles.worklistButtonRight}>
                  <div className={styles.worklistDirectButton} onClick={this._handleWorklist1Click}>
                    <Icon name={'worklist_1'} size="default" />
                  </div>
                  <div className={styles.worklistDirectButton} onClick={this._handleWorklist2Click}>
                    <Icon name={'worklist_2'} size="default" />
                  </div>
                </div>
              </div>
              <div
                className={classNames(
                  styles.cartButton,
                  location.pathname.startsWith('/cart') && styles.isActive
                )}
                onClick={this._handleCartClick}
              >
                <Icon name={'shopping_cart'} size="default" />
                {t('CART')}
              </div>
              <div
                className={classNames(
                  styles.reportButton,
                  'ignore-react-onclickoutside',
                  location.pathname.startsWith('/purchase') && styles.isActive
                )}
                onClick={this._toggleReportVisibility}
              >
                <Icon name={'history'} size="default" />
                {t('REPORT')}
              </div>
              <div className={styles.menuPopoverContainer}>
                <MenuPopover
                  visible={isMenuPopoverVisible && menuPopoverGroup === 'REPORT'}
                  onClickOutside={() => this.setState({ isMenuPopoverVisible: false })}
                  items={menuPopoverItems}
                />
              </div>
              <div
                className={classNames(styles.profileButton, 'ignore-react-onclickoutside')}
                onClick={this._toggleProfileVisibility}
              >
                <Icon name={'person'} size="default" />
                {t('PROFILE')}
              </div>
              <div className={styles.menuPopoverContainer}>
                <MenuPopover
                  visible={isMenuPopoverVisible && menuPopoverGroup === 'PROFILE'}
                  onClickOutside={() => this.setState({ isMenuPopoverVisible: false })}
                  items={menuPopoverItems}
                />
              </div>
              <div
                className={classNames(styles.infoButton, 'ignore-react-onclickoutside')}
                onClick={this._toggleInfoVisibility}
              >
                <Icon name={'info'} size="default" />
                {t('INFO')}
              </div>
              <div className={styles.menuPopoverContainer}>
                <MenuPopover
                  visible={isMenuPopoverVisible && menuPopoverGroup === 'INFO'}
                  onClickOutside={() => this.setState({ isMenuPopoverVisible: false })}
                  items={menuPopoverItems}
                />
              </div>
              {/* <div className={styles.usageButton} onClick={this._handleUsageClick}>
              <Icon name={'worklist'} />
              {t('USAGE')}
            </div>
            <div className={styles.productionsButton} onClick={this._handleProductionClick}>
              <Icon name={'worklist'} />
              {t('PRODUCTIONS')}
            </div> */}
            </div>
          </Toolbar>
          <div className={styles.links}>
            {links.map((link: any, index) => {
              return (
                <NavLink
                  key={`toolbar-link-${index}`}
                  className={styles.link}
                  activeClassName={styles.linkActive}
                  to={link.to}
                  isActive={link.isActive}
                >
                  <span className={styles.linkText}>{link.label}</span>
                  <Icon
                    name={link.icon}
                    size={'small'}
                    style={{ paddingLeft: 4, color: 'rgba(255, 255, 255, 0.7)' }}
                  />
                </NavLink>
              );
            })}
            {/* <div
              style={{
                marginLeft: 'auto',
                marginRight: 4,
              }}
            >
              {`${t('SESSION_USAGE')}: ${sessionUsageName}`}
            </div> */}
          </div>
        </div>
        {isAskHelopModalVisible && (
          <Modal
            title={t('HELP')}
            onDismiss={() => {
              this.setState({ isAskHelopModalVisible: false });
            }}
          >
            <OnDemandRequestsForm
              initialValues={helpFormInitialValues}
              onSubmit={this._handleAskHelpSubmit}
            />
          </Modal>
        )}
      </div>
    );
  }
}

export default withTranslation()(withRouter(connect(mapStateToProps, actions)(Header)));
